import { IDict } from '../types/utility';
import { ISources } from '../types';

export const REMOVE_ROUTE = 'default/remove_user_config';
export const GET_ROUTE = 'default/get_user_config';
export const SET_ROUTE = 'default/set_user_config';

export default function userConfigDataSetup(sources: ISources, moduleId: string): void {
    if (sources.requestExtensionData) {
        sources.getUserConfig = (namespace: string = moduleId) => {
            return sources.requestExtensionData!<IDict<any> | any>({
                route: GET_ROUTE,
                body: { namespace }
            }).then(response => {
                return response.data;
            });
        };
        sources.getUserConfigByKey = (key: string, namespace: string = moduleId) => {
            return sources.getUserConfig!(namespace).then(data => data[key]);
        };
        sources.setUserConfig = (key, value, namespace: string = moduleId) => {
            return sources.requestExtensionData!<void>({
                route: SET_ROUTE,
                body: { namespace, key, value }
            }).then(response => Promise.resolve());
        };
        sources.removeUserConfig = (key, namespace: string = moduleId) => {
            return sources.requestExtensionData!<void>({
                route: REMOVE_ROUTE,
                body: {
                    namespace,
                    key
                }
            }).then(response => Promise.resolve());
        };
    }
}
